<div class="usage-history-dialog">
    <header class="dialog-header">
        <h3>DTR Copilot Usage — {{ userName }}</h3>
    </header>
    <button mat-icon-button class="close-button" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <div class="dialog-content">
        <div *ngIf="loading" style="color: gray; padding: 20px 0;">Loading…</div>
        <div *ngIf="error" style="color: #b00020; padding: 20px 0;">Couldn't load usage history.</div>

        <ng-container *ngIf="!loading && !error">
            <div *ngIf="isSuperAdmin()" style="margin-bottom: 12px;">
                <button mat-stroked-button color="warn" [disabled]="resetting" (click)="onResetUsage()">
                    <mat-icon>restart_alt</mat-icon>
                    {{ resetting ? 'Resetting…' : "Reset Today's Usage" }}
                </button>
                <span *ngIf="resetError" style="color: #b00020; font-size: 12px; margin-left: 10px;">
                    Couldn't reset usage — try again.
                </span>
            </div>
            <p style="color: gray; font-size: 13px; margin-top: 0;">
                Daily usage as a percent of the daily cap in effect today, last 30 days.
            </p>
            <svg [attr.viewBox]="'0 0 ' + chartWidth + ' ' + chartHeight" style="width: 100%; height: auto;">
                <!-- Cap reference line (100%) -->
                <line x1="0" y1="0" [attr.x2]="chartWidth" y2="0" stroke="#888" stroke-width="1" stroke-dasharray="4,3" />

                <g *ngFor="let bar of bars">
                    <rect [attr.x]="bar.x" [attr.y]="bar.y" [attr.width]="bar.width" [attr.height]="bar.height"
                          [attr.fill]="bar.color">
                        <title>{{ bar.date }}: {{ bar.usedCredits.toFixed(0) }} credits ({{ bar.usedTokens.toLocaleString() }} tokens, {{ bar.percent }}%)</title>
                    </rect>
                    <text *ngIf="bar.showLabel" [attr.x]="bar.labelX" [attr.y]="barAreaHeight + 16"
                          text-anchor="middle" font-size="10" fill="#aaa">{{ bar.labelText }}</text>
                </g>
            </svg>
        </ng-container>
    </div>

    <div class="dialog-actions">
        <button mat-button (click)="close()">Close</button>
    </div>
</div>
